import React, { Component } from 'react'

const SCROLL_END_THRESHOLD_PX = 8

export default class ScrollDownIndicator extends Component {
  state = { visible: false }

  componentDidMount() {
    this.attachListeners()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scrollEl !== this.props.scrollEl || prevProps.contentKey !== this.props.contentKey) {
      this.detachListeners()
      this.attachListeners()
    }
  }

  componentWillUnmount() {
    this.detachListeners()
  }

  attachListeners = () => {
    const el = this.props.scrollEl
    if (!el) {
      this.setState({ visible: false })
      return
    }

    el.addEventListener('scroll', this.updateVisibility, false)
    this.updateVisibility()

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.updateVisibility)
      this.resizeObserver.observe(el)
      Array.from(el.children).forEach((child) => this.resizeObserver.observe(child))
    } else {
      window.addEventListener('resize', this.updateVisibility, false)
    }
  }

  detachListeners = () => {
    const el = this.props.scrollEl
    if (el) {
      el.removeEventListener('scroll', this.updateVisibility, false)
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }

    window.removeEventListener('resize', this.updateVisibility, false)
  }

  updateVisibility = () => {
    const el = this.props.scrollEl
    if (!el) {
      if (this.state.visible) {
        this.setState({ visible: false })
      }
      return
    }

    const hasOverflow = el.scrollHeight > el.clientHeight + 1
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_END_THRESHOLD_PX
    const visible = hasOverflow && !atBottom

    if (visible !== this.state.visible) {
      this.setState({ visible })
    }
  }

  handleClick = () => {
    const el = this.props.scrollEl
    if (!el) return

    const amount = Math.round(el.clientHeight * 0.75)
    if (el.scrollBy) {
      el.scrollBy({ top: amount, behavior: 'smooth' })
    } else {
      el.scrollTop += amount
    }
  }

  render() {
    const { className = '', inline = false } = this.props

    if (!this.state.visible) return null

    const button = (
      <button
        type="button"
        onClick={this.handleClick}
        className={[
          'inline-flex items-center gap-2 text-sm font-medium text-base-gray-text-secondary',
          'underline hover:text-base-gray-text-main focus:outline-hidden focus-visible:ring-2',
          'focus-visible:ring-base-blue-main rounded-xs',
          className,
        ].join(' ')}
      >
        Scroll Down
        <hero-icon-outline name="chevron-double-down" class="h-4 w-4 shrink-0" />
      </button>
    )

    if (inline) return button

    return (
      <div className="shrink-0 flex justify-end items-center py-2 bg-surface">
        {button}
      </div>
    )
  }
}

